import React from 'react'
import classnames from 'classnames'

const Icon = ({symbol, spin, fw, className, ...other}) => (
  <i {...other} className={classnames(
    className,
    `sidx-${symbol}`,
    'sidx-icon',
    'sidx-fa',
    `sidx-fa-${symbol}`,
    { 'sidx-fa-spin' : spin, 'sidx-fa-fw' : fw }
  )}/>
)

export default Icon



// WEBPACK FOOTER //
// client/components/icon.js